// Secure OpenAI API handler - calls Firebase Function instead of OpenAI directly
// This prevents API key exposure in the browser
import { httpsCallable } from 'firebase/functions'
import { functions } from './firebase'

export const getChatCompletion = async (
  messages,
  model = 'gpt-3.5-turbo',
  temperature = 0.1,
  quota = null
) => {
  try {
    // Call the secure Firebase Function instead of OpenAI directly
    const callOpenAI = httpsCallable(functions, 'callOpenAI')
    const payload = {
      messages: messages,
      model: model,
      temperature: temperature
    }
    if (quota && typeof quota === 'object') {
      if (quota.questionHash) payload.questionHash = quota.questionHash
      if (quota.explainSessionId) payload.explainSessionId = quota.explainSessionId
      if (quota.helperAttemptId) payload.helperAttemptId = quota.helperAttemptId
      if (quota.studentId) payload.studentId = quota.studentId
    }

    const result = await callOpenAI(payload)

    if (!result.data || !result.data.success) {
      throw new Error('Invalid response from server')
    }

    return result.data.content
  } catch (error) {
    console.error('OpenAI API Error:', error)

    const quotaDetails = error && error.details
    if (quotaDetails && quotaDetails.reason === 'helper_quota_exceeded') {
      const wrapped = new Error(error.message || 'Weekly session limit reached')
      wrapped.details = quotaDetails
      wrapped.code = error.code
      throw wrapped
    }

    // Handle Firebase Function errors
    if (error.code === 'unauthenticated') {
      throw new Error('You must be logged in to use this feature.')
    }

    if (error.code === 'failed-precondition') {
      throw new Error('OpenAI API is not configured. Please contact support.')
    }

    if (error.code === 'resource-exhausted') {
      throw new Error('OpenAI API quota exceeded. Please try again later.')
    }

    if (error.message && error.message.includes('quota')) {
      throw new Error('OpenAI API quota exceeded. Please check your billing.')
    }

    if ((error.message && error.message.includes('network')) || error.name === 'TypeError') {
      throw new Error('Network error. Please check your internet connection.')
    }

    throw new Error(`OpenAI API failed: ${error.message || 'Unknown error'}`)
  }
}

export const analyzeText = async (text, prompt = "Analyze this text:") => {
  const messages = [
    { role: "system", content: "You are a helpful assistant." },
    { role: "user", content: `${prompt} ${text}` }
  ];

  return await getChatCompletion(messages);
};